// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showSketch } from '../../actions/sketchHostActions';

type ProvidedProps = {
    dispatch: Function,
    jwt: string,
    match: {
        params: {
            id: string,
            projectId: string,
        }
    },
}

class SketchRoute extends Component<ProvidedProps> {
    formRef: Object;

    constructor(props) {
        super(props);

        this.formRef = React.createRef();
    }

    async componentDidMount() {
        await this.openSketch();
    }

    async componentDidUpdate() {
        await this.openSketch();
    }

    openSketch = async () => {
        if (window.location.href.includes('showExp')) {
            this.formRef.current.submit();
        } else {
            this.props.dispatch(showSketch(this.props.match.params.id, this.props.match.params.projectId));
        }
    };

    getRefUrlBackToOrdersPage = () => {
        const url = window.location.href;
        const index = url.lastIndexOf('/sketch');
        if (index !== -1) {
            return url.substr(0, index);
        } else {
            console.warn('unable to setup ref correctly');
            return url;
        }
    };

    render() {
        const baseUrl = process.env.REACT_APP_EXP_SKETCHTOOL_URL || '';
        if (baseUrl === '') {
            console.warn('unable to find process.env.REACT_APP_EXP_SKETCHTOOL_URL!');
        }
        const env = process.env.REACT_APP_ENVIRONMENT
            ? process.env.REACT_APP_ENVIRONMENT.endsWith('development') ? 'dev' : 'prod'
            : 'dev';
        return (
            <div style={{ display: 'none' }}>
                <form method="post" action={`${baseUrl}/show`} ref={this.formRef}>
                    <input type="hidden" name="jwt" value={this.props.jwt}/>
                    <input type="hidden" name="projectId" value={this.props.match.params.projectId}/>
                    <input type="hidden" name="ref" value={this.getRefUrlBackToOrdersPage()}/>
                    <input type="hidden" name="env" value={env}/>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        jwt: state.auth.accessToken
    }
};

export default connect(mapStateToProps)(SketchRoute);
